import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import List from "../../components/organisms/List";
import request from "../../config/Axios";

const Announcement = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "공지",
            link: "/notice/announcement"
        },
        {
            name: "캠페인",
            link: "/notice/campaign"
        },
        {
            name: "강아지숲 이야기",
            link: "/notice/dstory"
        },
        {
            name: "자주하는 질문",
            link: "/notice/faq"
        },
    ];
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);

    useEffect(() => {
        (async () => {
            try {
                const noticeResponse = await request.get(`boards/announcement/posts`, {
                    params: {
                        page: page
                    }
                });
                setRow(noticeResponse.data.data.postList);
                setTotalPages(noticeResponse.data.data.totalPages);
                window.scrollTo(0, 500);

            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, [page]);

    return (
        <>
            <PageHeader
                bTitle="알림"
                detail="공지"
                desc="강아지숲의 공지를 안내해 드립니다."
                list={navList}
                top={true}

            />
            <List
                row={row}
                columns={3}
                totalPages={totalPages}
                page={page}
                changePage={setPage}
            />
        </>
    );
};

export default Announcement;
